"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletIcon = exports.ProfileIcon = exports.LeaderboardIcon = exports.ScoresIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoresIcon = function ScoresIcon() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.9948 22.0771C19.4068 22.0771 18.9308 22.5391 18.9308 23.1271C18.9308 23.7151 19.4068 24.1771 19.9948 24.1771C20.5828 24.1771 21.0588 23.7151 21.0588 23.1271C21.0588 22.5391 20.5828 22.0771 19.9948 22.0771ZM19.9948 16.5891C19.4068 16.5891 18.9308 17.0511 18.9308 17.6391C18.9308 18.2271 19.4068 18.6891 19.9948 18.6891C20.5828 18.6891 21.0588 18.2271 21.0588 17.6391C21.0588 17.0511 20.5828 16.5891 19.9948 16.5891Z",
      fill: "white"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3 8C1.89543 8 1 8.89543 1 10V29.2836C1 30.3882 1.89543 31.2836 3 31.2836H13.7774C14.882 31.2836 15.7774 30.3882 15.7774 29.2836V10C15.7774 8.89543 14.882 8 13.7774 8H3ZM9.44057 22.6838H11.5331V24.1972H5.6504V22.6838H7.72973V16.4984H5.96625V14.985H9.44057V22.6838Z",
      fill: "white"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M26.2227 8C25.1181 8 24.2227 8.89543 24.2227 10V29.2836C24.2227 30.3882 25.1181 31.2836 26.2227 31.2836H37.0001C38.1047 31.2836 39.0001 30.3882 39.0001 29.2836V10C39.0001 8.89543 38.1047 8 37.0001 8H26.2227ZM31.7575 14.8402C33.5999 14.8402 34.9028 16.0114 34.9028 17.6433C34.9028 18.6698 34.508 19.4726 33.3894 20.6175L31.3232 22.71H34.9686V24.1971H28.7306V23.1575L32.2181 19.5647C32.9419 18.8146 33.1656 18.4198 33.1656 17.8012C33.1656 16.9458 32.4945 16.3273 31.5732 16.3273C30.8099 16.3273 30.2046 16.6958 29.586 17.4591L28.4674 16.4194C29.3097 15.3929 30.4151 14.8402 31.7575 14.8402Z",
      fill: "white"
    })]
  });
};

exports.ScoresIcon = ScoresIcon;

var LeaderboardIcon = function LeaderboardIcon() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M14.3556 28.8C14.3556 29.9046 13.4601 30.8 12.3556 30.8H10C8.89543 30.8 8 29.9046 8 28.8V18.9333C8 17.8288 8.89543 16.9333 10 16.9333H12.3556C13.4601 16.9333 14.3556 17.8288 14.3556 18.9333V28.8ZM22.7333 12C22.7333 10.8954 21.8379 10 20.7333 10H18.3778C17.2732 10 16.3778 10.8954 16.3778 12V28.8C16.3778 29.9046 17.2732 30.8 18.3778 30.8H20.7333C21.8379 30.8 22.7333 29.9046 22.7333 28.8V12ZM31.1111 21.2444C31.1111 20.1399 30.2157 19.2444 29.1111 19.2444H26.7556C25.651 19.2444 24.7556 20.1399 24.7556 21.2444V28.8C24.7556 29.9046 25.651 30.8 26.7556 30.8H29.1111C30.2157 30.8 31.1111 29.9046 31.1111 28.8V21.2444Z",
      fill: "white"
    })
  });
};

exports.LeaderboardIcon = LeaderboardIcon;

var ProfileIcon = function ProfileIcon() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M26 13.7391C26 16.9088 23.3137 19.5 20 19.5C16.6863 19.5 14 16.9088 14 13.7391C14 10.5695 16.6863 8 20 8C23.3137 8 26 10.5695 26 13.7391Z",
      fill: "white"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10 26.5C10 24.0147 12.0147 22 14.5 22H25.5C27.9853 22 30 24.0147 30 26.5V31H10V26.5Z",
      fill: "white"
    })]
  });
};

exports.ProfileIcon = ProfileIcon;

var WalletIcon = function WalletIcon() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 9C6.89543 9 6 9.89543 6 11V17C7.65685 17 9 18.3431 9 20C9 21.6569 7.65685 23 6 23V28C6 29.1046 6.89543 30 8 30H23V9H8ZM26 9V30H32C33.1046 30 34 29.1046 34 28V23C32.3431 23 31 21.6569 31 20C31 18.3431 32.3431 17 34 17V11C34 9.89543 33.1046 9 32 9H26Z",
      fill: "white"
    })
  });
};

exports.WalletIcon = WalletIcon;